import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LoginContract } from './login/LoginContract';
import { LoginLayout } from './login/LoginLayout';
import CeoInfo from './screens/ceo/CeoInfo';
import Dashboard from './screens/dashboard/Dashboard';
import { ProtectedLayout } from './screens/ProtectedLayout';
// import Inventory from './screens/product/inventoryManage/Inventory';

import { Login } from './login/Login';
import SaleCategory from './screens/sales/CategorySale';
// import SalesDaily from './screens/sales/Daily';
import Analysis from './screens/sales/Analysis';
import SalesPeriod from './screens/sales/Period';
import SalesProduct from './screens/sales/ProductSale';

import LoadingPage from './login/LoadingPage';
import { LoginForgetMain } from './login/loginForget/LoginForgetMain';
import { LoginHotel } from './login/LoginHotel';
import { LoginUserJoinMain } from './login/loginUserJoin/LoginUserJoinMain';
import { AuthContext } from './navigation/AuthProvider';
import AdvertiseCategory from './screens/advertise/AdvertiseCategory';
import AdvertiseStatus from './screens/advertise/AdvertiseStatus';
import AdvertiseUpload from './screens/advertise/AdvertiseUpload';
import HotelCheckoutList from './screens/hotel/Checkout/HotelCheckoutList';
import ConciergeSetting from './screens/hotel/Concierge/ConciergeSetting';
import StaffSetting from './screens/hotel/Concierge/StaffSetting';
import DeliverySales from './screens/hotel/DeliverySales';
import HotelEvent from './screens/hotel/event/HotelEvent';
import GuideEdit from './screens/hotel/guide/GuideEdit';
import GuideIndex from './screens/hotel/guide/GuideIndex';
import HotelDeviceSetting from './screens/hotel/HotelDeviceSetting';
import HotelInfo from './screens/hotel/HotelInfo';
import HotelCheckOut from './screens/hotel/HotelNotice/HotelNoticeMain';
import HotelPickupSetting from './screens/hotel/HotelPickupSetting';
import HotelTip from './screens/hotel/HotelTip';
import InterphoneSetting from './screens/hotel/interphone/InterphoneSetting';
import InterphoneAreaIndex from './screens/hotel/interphoneArea/InterphoneAreaIndex/InterphoneAreaIndex';
import RequestChatList from './screens/hotel/RequestChat/RequestChatList';
import HotelRoomType from './screens/hotel/RoomType/HotelAddRoomType';
import HotelRoomSale from './screens/hotel/RoomType/HotelRoomSale';
import SalesManager from './screens/hotel/SalesManager/SalesManager';
import StoreInspect from './screens/inspect/StoreInspect';
import NotificationIndex from './screens/notification/NotificationIndex';
import CouponEdit from './screens/product/coupon/CouponEdit';
import CouponIndex from './screens/product/coupon/CouponIndex';
import Inventory from './screens/product/inventory/Inventory';
import CategoryEdit from './screens/product/menu/CategoryEdit';
import CategoryIndex from './screens/product/menu/CategoryIndex';
import ProductEdit from './screens/product/product/ProductEdit';
import ProductIndex from './screens/product/product/ProductIndex';
import OptionEdit from './screens/product/productOption/OptionEdit';
import OptionIndex from './screens/product/productOption/OptionIndex';
import SetMenuEdit from './screens/product/setMenu/SetMenuEdit';
import SetMenuIndex from './screens/product/setMenu/SetMenuIndex';
import SetItemEdit from './screens/product/setMenuItem/SetItemEdit';
import SetItemIndex from './screens/product/setMenuItem/SetItemIndex';
import SalesHotel from './screens/sales/SalesHotel';
import SalesMonthly from './screens/sales/SalesMonthly';

const App = () => {
  const { userInfo } = useContext(AuthContext);

  React.useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/kakaotalk/i.test(userAgent)) {
      if (/iPhone|iPad|iPod/i.test(userAgent)) {
        setTimeout(() => {
          window.location.href = 'kakaoweb://closeBrowser';
        }, 100);
      } else {
        window.location.href = 'kakaotalk://inappbrowser/close';
      }
      window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
        `${window.location.origin}${process.env.REACT_APP_BASE_URL}${
          userInfo ? '' : '/login?redirect='
        }${window.location.pathname.replace(process.env.REACT_APP_BASE_URL || '', '')}`,
      )}`;
    }

    if (document) {
      let oDoc: any = document;
      if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest.json');
      } else {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest_dev.json');
      }
    }
  }, []);

  return (
    <Routes>
      <Route element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/posLogin" element={<LoadingPage />} />
        <Route path="/loginIdForget" element={<LoginForgetMain typeForgot={'id'} />} />
        <Route path="/loginPasswordForget" element={<LoginForgetMain typeForgot={'password'} />} />
        <Route path="/loginUserJoin" element={<LoginUserJoinMain />} />
        <Route path="/loginContract" element={<LoginContract />} />
        <Route path="/loginHotel" element={<LoginHotel />} />
      </Route>

      <Route path="/" element={<ProtectedLayout />}>
        <Route path="dashboard" element={<Dashboard />} />

        {/* 판매관리 */}
        {/* <Route path="/store" element={<StoreLayout />}> */}
        <Route path="/manage/salemanager" element={<SalesManager />} />
        <Route path="/manage/delivery" element={<DeliverySales />} />
        <Route path="/manage/sales" element={<SalesPeriod />} />

        {/* 객실관리 */}
        <Route path="/room/checkout" element={<HotelCheckOut />} />
        <Route path="/room/checkList" element={<HotelCheckoutList />} />
        <Route path="/room/request" element={<RequestChatList />} />
        <Route path="/room/interphone" element={<InterphoneSetting />} />

        {/* 호텔관리 */}
        <Route path="/info/guide" element={<GuideIndex />} />
        <Route path="/info/guide/edit/:card_id" element={<GuideEdit />} />
        <Route path="/info/StaffSetting" element={<StaffSetting />} />

        {/* 설정 */}
        <Route path="/setting/hotelInfo" element={<HotelInfo />} />
        <Route path="/room/device" element={<HotelDeviceSetting />} />
        <Route path="/setting/pickup" element={<HotelPickupSetting />} />
        <Route path="/setting/tip" element={<HotelTip />} />
        <Route path="/setting/roomType" element={<HotelRoomType />} />
        <Route path="/room/roomSale" element={<HotelRoomSale />} />
        <Route path="/setting/concierge" element={<ConciergeSetting />} />
        <Route path="/setting/area" element={<InterphoneAreaIndex />} />

        {/* 미지정 */}
        <Route path="/hotel/event" element={<HotelEvent />} />

        {/* 검수 */}
        <Route path="/inspect" element={<StoreInspect />} />

        {/* 상품관리 */}
        <Route path="product/category" element={<CategoryIndex />} />
        <Route path="product/category/edit" element={<CategoryEdit />} />
        <Route path="product/product" element={<ProductIndex />} />
        <Route path="product/product/edit" element={<ProductEdit />} />
        <Route path="product/option" element={<OptionIndex />} />
        <Route path="product/option/edit" element={<OptionEdit />} />
        <Route path="product/setmenu" element={<SetMenuIndex />} />
        <Route path="product/setmenu/edit" element={<SetMenuEdit />} />
        <Route path="product/setitem" element={<SetItemIndex />} />
        <Route path="product/setitem/edit" element={<SetItemEdit />} />
        <Route path="product/inventory" element={<Inventory />} />
        <Route path="product/coupon" element={<CouponIndex />} />
        <Route path="product/coupon/edit" element={<CouponEdit />} />

        {/* 매출 관리 */}
        <Route path="sales/analysis" element={<Analysis />} />
        {/* <Route path="sales/daily" element={<SalesDaily />} /> */}
        <Route path="sales/monthly" element={<SalesMonthly />} />
        <Route path="sales/category" element={<SaleCategory />} />
        <Route path="sales/product" element={<SalesProduct />} />
        <Route path="/sales/hotel" element={<SalesHotel />} />

        {/* 광고관리 */}
        <Route path="/advertise/category" element={<AdvertiseCategory />} />
        <Route path="/advertise/status" element={<AdvertiseStatus />} />
        <Route path="/advertise/upload" element={<AdvertiseUpload />} />

        {/* 호텔정보 */}
        <Route path="/advertise/category" element={<AdvertiseCategory />} />

        {/* </Route> */}

        <Route path="ceo/info" element={<CeoInfo />} />

        <Route path="notification/list" element={<NotificationIndex />} />
      </Route>
    </Routes>
  );
};

export default App;
